// University of Richmond's undergraduate majors (#2744). Read on 2026-10-01
// from the university's official Majors, Minors, and Concentrations page
// (richmond.edu/academics/majors), which lists each program with what it is
// available as (major, minor, concentration), the degree it confers and the
// school. Every program available as a major is kept, once per degree it
// confers; minor-only and concentration-only programs are left out. The page
// spells degrees out; B.A. and B.S. abbreviate Bachelor of Arts and of
// Science, and B.S.B.A. is the undergraduate catalog's own abbreviation. Economics is offered both as a
// B.A. in Arts and Sciences and as a B.S.B.A. in the Robins School, so it
// appears in both groups. The undergraduate catalog's program pages load by
// script, so the majors page is the source. The KB's majors list was the
// starting point; the official list wins.
const majors = {
    "slug": "university-of-richmond",
    "read": "2026-10-01",
    "intro": "Every major on Richmond's official list of majors, minors and concentrations, grouped by the school that confers the degree, with the degree it leads to. Minors, concentrations and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Arts and Sciences",
            "source": {
                "label": "University of Richmond, Majors, Minors, and Concentrations",
                "url": "https://www.richmond.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Arabic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chinese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Film Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender & Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Greek",
                    "degree": "B.A."
                },
                {
                    "name": "Health Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American, Latino, and Iberian Studies (Spanish)",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy, Politics, Economics and Law (PPEL)",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Rhetoric and Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Visual and Media Arts Practice",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Jepson School of Leadership Studies",
            "source": {
                "label": "University of Richmond, Majors, Minors, and Concentrations",
                "url": "https://www.richmond.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Leadership Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Robins School of Business",
            "source": {
                "label": "University of Richmond, Majors, Minors, and Concentrations",
                "url": "https://www.richmond.edu/academics/majors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B.A."
                }
            ]
        }
    ]
};

export default majors;
